import Parser from 'html-react-parser';

import l from '../../../../lang';
import Card from '../../../common/card';
import { ReactComponent as DocumentCheckedImage } from '../../../../assets/images/document-checked.svg';
import './styles.scss';

const PendingKyc2 = () => {
  return (
    <Card>
      <div className="pending-kyc-2">
        <div className="pending-kyc-2__icon" aria-hidden>
          <DocumentCheckedImage />
        </div>
        <div className="pending-kyc-2__content">
          <h3 className="pending-kyc-2__title">{l('home.pendingKyc2.title')}</h3>
          <p className="pending-kyc-2__desc">{Parser(l('home.pendingKyc2.desc'))}</p>
        </div>
      </div>
    </Card>
  );
};

export default PendingKyc2;
